import interstellarApi from './interstellarApi';

export interface UnavailableReason {
  id: number;
  name: string;
  position: number;
  is_active: boolean;
}

export interface UpdateUnavailableReasonPayload {
  name?: string;
  position?: number;
  is_active?: boolean;
}

/**
 * Lista motivos de "No disponible": `GET /incoming-call-config/unavailable-reasons`
 */
export const fetchUnavailableReasons = async (
  accountId: number,
  activeOnly = false
): Promise<UnavailableReason[]> => {
  const response = await interstellarApi.get<UnavailableReason[]>(
    '/incoming-call-config/unavailable-reasons',
    { params: { account_id: accountId, active_only: activeOnly } }
  );
  return response.data ?? [];
};

/**
 * Crea un motivo: `POST /incoming-call-config/unavailable-reasons`
 */
export const createUnavailableReason = async (
  accountId: number,
  name: string,
  position: number
): Promise<UnavailableReason> => {
  const response = await interstellarApi.post<UnavailableReason>(
    '/incoming-call-config/unavailable-reasons',
    { account_id: accountId, name, position }
  );
  return response.data;
};

/**
 * Actualiza un motivo: `PUT /incoming-call-config/unavailable-reasons/{id}`
 */
export const updateUnavailableReason = async (
  reasonId: number,
  payload: UpdateUnavailableReasonPayload
): Promise<UnavailableReason> => {
  const response = await interstellarApi.put<UnavailableReason>(
    `/incoming-call-config/unavailable-reasons/${reasonId}`,
    payload
  );
  return response.data;
};

/**
 * Desactiva un motivo (borrado lógico): `DELETE /incoming-call-config/unavailable-reasons/{id}`
 */
export const deleteUnavailableReason = async (reasonId: number): Promise<void> => {
  await interstellarApi.delete(`/incoming-call-config/unavailable-reasons/${reasonId}`);
};

/**
 * Crea los motivos por defecto si la cuenta no tiene: `POST /incoming-call-config/unavailable-reasons/defaults`
 */
export const createDefaultUnavailableReasons = async (
  accountId: number
): Promise<UnavailableReason[]> => {
  const response = await interstellarApi.post<UnavailableReason[]>(
    '/incoming-call-config/unavailable-reasons/defaults',
    null,
    { params: { account_id: accountId } }
  );
  return response.data ?? [];
};
